import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CrossTeamSharedModule } from '../../cross-team-shared/cross-team-shared.module';
import { Shared2DModule } from '../shared/shared-2d.module';
import { MainVideoToolbarComponent } from './toolbars/main-toolbar/main-video-toolbar.component';
import { SplitViewMainVideoToolbarComponent } from './toolbars/main-toolbar/split-view-main-video-toolbar.component';
import { VideoContentInitializerComponent } from './video-content-initializer/video-content-initializer.component';

const exportedItems = [
  VideoContentInitializerComponent,
  MainVideoToolbarComponent,
  SplitViewMainVideoToolbarComponent,
];

@NgModule({
  imports: [CommonModule, CrossTeamSharedModule, FormsModule, Shared2DModule],
  declarations: [exportedItems],
  exports: [exportedItems, Shared2DModule],
})
export class VideoContentModule {}
